<script>
import OrderBasketStep from './components/order-steps/order-basket-step.vue';
import OrderPersonalStep from './components/order-steps/order-personal-step.vue';
import OrderDeliveryStep from './components/order-steps/order-delivery-step.vue';
import OrderPaymentStep from './components/order-steps/order-payment-step.vue';
import OrderFinalStep from '@/components/order-vue/order/components/order-steps/order-final-step.vue';
import OrderTitle from './components/order-title.vue';
import BasketEmpty from './components/basket/basket-empty.vue';

import { mapActions, mapState } from 'pinia';
import { basketStore } from '../stores/basket';
import { orderStore } from '../stores/order';
import { alertsStore } from '../stores/alerts';
import { useInputsStore } from '../stores/inputs';
import { useEventBus } from '../stores/eventBus.js';
import PopupLayer from '@/components/order-vue/order/components/popups/popup-layer.vue';
import OrderRegisterError from '@/components/order-vue/order/components/popups/order-register-error.vue';
import BasketErrors from '@/components/order-vue/order/components/basket-errors.vue';


/**
 * Базовый компонент оформления заказа
 */
export default {
	components: {
		BasketErrors,
		OrderRegisterError,
		PopupLayer,
		OrderFinalStep,
		OrderBasketStep,
		OrderPersonalStep,
		OrderDeliveryStep,
		OrderPaymentStep,
		OrderTitle,
		BasketEmpty
	},
	
	inject: [
		'basketMode',
		'orderMode',
		'combinedMode',
		'initialOrderData',
		'defaultUserAgreementStatus',
		'basketPageLocation',
		'orderPageLocation',
		'debugMode'
	],
	
	computed: {
		...mapState(
			basketStore,
			{
				isBaskedInitialized: 'isInitialized',
				isBaskedLoaded: 'isLoaded',
				isBaskedEmpty: 'isEmpty',
				isBasketOrderable: 'isOrderable'
			}
		),
		...mapState(
			orderStore,
			{
				isOrderLoaded: 'isLoaded',
				isPickupDeliverySystemSelected: 'isPickupDeliverySystemSelected',
			}
		),
		
		...mapState(
			useInputsStore,
			{
				isValid: 'isValidAll',
			}
		),
		
		...mapState(
			alertsStore, { hasBasketErrors: 'hasErrors' }
		),
	},

	methods: {
		...mapActions(
			basketStore,
			{
				isBasketInitialized : 'isInitialized',
				initBasketStorage: 'init',
				setBasketData: 'setBasketData',
				reloadBasketStorage: 'reloadBasketData',
				setBasketDebugStatus: 'changeDebugStatus',
			}
		),
		...mapActions(
			orderStore,
			{
				isOrderInitialized : 'isInitialized',
				initOrderStorage: 'init',
				disableOrderStorage: 'disable',
				reloadOrderStorage: 'reloadOrderData',
				setOrderData: 'setOrderData',
				setOrderUserAgreementStatus: 'changeUserAgreementStatus',
				setOrderDebugStatus: 'changeDebugStatus',
			}
		),
		...mapActions(
			alertsStore,
			{
				initAlertsStorage: 'init'
			}
		),

		initialize() {
			this.initBasketStorage();
			this.initOrderStorage();
			this.initAlertsStorage();

			this.setBasketDebugStatus(this.debugMode);
			this.setOrderDebugStatus(this.debugMode);

			this.setOrderUserAgreementStatus(this.defaultUserAgreementStatus);
			
			if (this.initialOrderData) {
				this.setOrderData(this.initialOrderData);
			} else {
				this.reloadOrderStorage();
			}
			
		},
	},

	mounted() {
		this.initialize();
		this.$nextTick(() => useEventBus().emit('o2k:order:componentLoaded'));
	}
};
</script>

<template>
	
	<BasketEmpty v-if="isBaskedInitialized && isBaskedEmpty"/>
	<template v-else-if="isBasketInitialized && isOrderInitialized">
		<OrderTitle/>
		<OrderBasketStep/>
		<div class="checkout">
			<hgroup class="checkout__hgroup">
				<h2 class="checkout__title">{{ $loc.get('ORDER_TITLE') }}</h2>
				<BasketErrors class="template-page__hgroup-error"/>
				<OrderRegisterError class="checkout__hgroup-error"/>
			</hgroup>
			
			<form 
				id="bx-soa-order-form" 
				ref="form" 
				name="ORDER_FORM" 
				class="checkout-items" 
				@submit.prevent=""
			>
				<OrderPersonalStep/>
				<OrderDeliveryStep/>
				<OrderPaymentStep/>
				<OrderFinalStep :is-valid="isValid && !hasBasketErrors"/>
				
				<p class="checkout-items__caption" v-html="$loc.get('SUMMARY_CAPTION')"></p>
			</form>
		</div>
		<Teleport to="body">
			<PopupLayer/>
		</Teleport>
	</template>
	
</template>
